package com.bulut.mecitogullari.data.repository

import com.bulut.mecitogullari.data.model.Craftsman
import com.bulut.mecitogullari.data.model.CraftsmanEntry
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

interface BarterRepository {
    val craftsmen: Flow<List<Craftsman>>
    val entries: Flow<List<CraftsmanEntry>>
    fun entriesFor(craftsmanId: String): Flow<List<CraftsmanEntry>>
    suspend fun upsertCraftsman(craftsman: Craftsman)
    suspend fun upsertEntry(entry: CraftsmanEntry)
    suspend fun deleteEntry(entryId: String)
    /** Removes the craftsman together with their whole account history. */
    suspend fun deleteCraftsman(craftsmanId: String)
}

class FirestoreBarterRepository : BarterRepository {

    override val craftsmen: Flow<List<Craftsman>> = userCollectionFlow(CRAFTSMEN)

    override val entries: Flow<List<CraftsmanEntry>> = userCollectionFlow(ENTRIES)

    override fun entriesFor(craftsmanId: String): Flow<List<CraftsmanEntry>> =
        entries.map { list -> list.filter { it.craftsmanId == craftsmanId } }

    override suspend fun upsertCraftsman(craftsman: Craftsman) {
        val uid = currentUid() ?: return
        userCollection(uid, CRAFTSMEN).document(craftsman.id).set(craftsman)
    }

    override suspend fun upsertEntry(entry: CraftsmanEntry) {
        val uid = currentUid() ?: return
        userCollection(uid, ENTRIES).document(entry.id).set(entry)
    }

    override suspend fun deleteEntry(entryId: String) {
        val uid = currentUid() ?: return
        userCollection(uid, ENTRIES).document(entryId).delete()
    }

    override suspend fun deleteCraftsman(craftsmanId: String) {
        val uid = currentUid() ?: return
        val snapshot = userCollection(uid, ENTRIES).get()
        snapshot.documents
            .filter { runCatching { it.data<CraftsmanEntry>().craftsmanId }.getOrNull() == craftsmanId }
            .forEach { it.reference.delete() }
        userCollection(uid, CRAFTSMEN).document(craftsmanId).delete()
    }

    private companion object {
        const val CRAFTSMEN = "craftsmen"
        const val ENTRIES = "craftsmanEntries"
    }
}
